import { logger } from '../utils/logger';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app/store';
import {
    isLoading,
    setPersonalList,
    loadDataPersonal,
    clearPersonalSelected,
    personalHabilitacionInitial,
} from '../context/PersonalHabilitacion/PersonalHabilitacionReducer';
import { PersonalHabilitacion } from '../types/PersonalHabilitacion';
import { findAll, save, update, remove } from '../services/Service';

export const usePersonalHabilitacion = () => {
    const BASE_URL = 'personal-habilitacion';

    const { personalList, personalSelected, loading } = useSelector(
        (state: RootState) => state.personalHabilitacion
    );
    const dispatch = useDispatch();

    const buscarPersonalByIdHabilitacion = async (id: number) => {
        dispatch(isLoading(true));
        await findAll(`${BASE_URL}/habilitacion/${id}`)
            .then((response) => {
                dispatch(setPersonalList(response.data.filter((p: any) => p.activo)));
            })
            .catch((error) => {
                logger.log(error);
                dispatch(setPersonalList([]));
            });
    };

    const buscarPersonalByDocumento = async (
        idTipoDocPersona: number,
        nroDocumento: string,
        setStateFunc: (data: any) => void
    ) => {
        await findAll(`${BASE_URL}/documento/find?idTipoDocPersona=${idTipoDocPersona}&nroDocumento=${nroDocumento}`)
            .then((response) => {
                setStateFunc(response.data);
            })
            .catch((error) => {
                logger.log(error);
                setStateFunc(null);
            });
    };

    const eliminarPersonal = async (id: string, idHabilitacion: number) => {
        await remove(BASE_URL, id)
            .then(() => {
                buscarPersonalByIdHabilitacion(idHabilitacion);
            })
            .catch((error) => {
                logger.log(error);
                throw error;
            });
    };

    const saveOrUpdatePersonal = async (personal: PersonalHabilitacion) => {
        try {
            if (personal.id === 0) {
                const result = await save(BASE_URL, personal);
                return result;
            } else {
                const result = await update(BASE_URL, personal);
                return result;
            }
        } catch (error) {
            logger.log(error);
            throw error;
        }
    };

    const handlePersonalSelected = (personal: PersonalHabilitacion) => {
        dispatch(loadDataPersonal(personal));
    };

    const handleClearPersonal = () => {
        dispatch(clearPersonalSelected());
    };

    return {
        personalList,
        personalSelected,
        loading,
        personalHabilitacionInitial,
        buscarPersonalByIdHabilitacion,
        buscarPersonalByDocumento,
        eliminarPersonal,
        saveOrUpdatePersonal,
        handlePersonalSelected,
        handleClearPersonal,
    };
};
